import type { ETFDetailTab } from "./equity-detail";

export type ETFDetailState = {
  etfTab: ETFDetailTab;
  refreshMessage: string;
  refreshError: string;
};

export type ETFDetailAction =
  | { type: "tickerChanged"; }
  | { type: "setETFTab"; value: ETFDetailTab; }
  | { type: "clearRefreshFeedback"; }
  | { type: "setRefreshMessage"; value: string; }
  | { type: "setRefreshError"; value: string; };

export function createInitialETFDetailState(): ETFDetailState {
  return {
    etfTab: "overview",
    refreshMessage: "",
    refreshError: "",
  };
}

export function etfDetailReducer(state: ETFDetailState, action: ETFDetailAction): ETFDetailState {
  switch (action.type) {
    case "tickerChanged":
      return {
        ...state,
        etfTab: "overview",
        refreshMessage: "",
        refreshError: "",
      };
    case "setETFTab":
      return {
        ...state,
        etfTab: action.value,
      };
    case "clearRefreshFeedback":
      return {
        ...state,
        refreshMessage: "",
        refreshError: "",
      };
    case "setRefreshMessage":
      return {
        ...state,
        refreshMessage: action.value,
        refreshError: "",
      };
    case "setRefreshError":
      return {
        ...state,
        refreshError: action.value,
        refreshMessage: "",
      };
    default:
      return state;
  }
}
